export default function paginationHelper({ pageIndex, pageSize, totalItems }) {
    let firstNumber = 0;
    if (totalItems !== 0) {
        firstNumber = pageIndex > 0 ? pageIndex * pageSize + 1 : 1;
    }
    if (firstNumber > totalItems && totalItems > 0) {
        firstNumber = pageSize + 1;
    }
    let secondNumber = firstNumber + pageSize - 1;
    if (secondNumber > totalItems) {
        secondNumber = totalItems;
    }
    return `${firstNumber} - ${secondNumber} of ${totalItems}`;
}
export const generateProps = (tableInstance) => ({
    setPageSize: tableInstance.setPageSize,
    canNextPage: tableInstance.canNextPage,
    canPreviousPage: tableInstance.canPreviousPage,
    nextPage: tableInstance.nextPage,
    pageIndex: tableInstance.state.pageIndex,
    pageSize: tableInstance.state.pageSize,
    previousPage: tableInstance.previousPage
});
